import React from 'react';

const DataLoader = ({label = 'Načítám data...'}) => {
    return (
        <div className="w-full min-h-[220px] flex flex-col items-center justify-center text-gray-500">
            <div className="w-7 h-7 border-2 border-gray-300 border-t-gray-700 rounded-full animate-spin mb-3"/>
            <div className="text-sm">{label}</div>
        </div>
    );
};

export default DataLoader;
